import React, { useState } from "react";
import styles from "./index.module.scss";
import { Link } from "../../../../../shared/ui/Link";
import { Input } from "../../../../../shared/ui/Input";
import { Button } from "../../../../../shared/ui/Button";
import { updateOfferVisitorCardNum } from "../../../../../shared/store/payment/api";
import { BANK__NAMES, BANK__ICONS } from "../../../../../shared/consts";
import { IOffer } from "../../../../../shared/store/payment/types";
import { getPaymentType } from "../../../../../shared/utils/cardType";
import { Form } from "../../../../../shared/ui/Form";
import { FormContainer } from "../../../../../shared/ui/FormContainer";
import alertIcon from "./assets/alert.svg";

const getBankName = (providerCode: string, providerName: string) => {
  return BANK__NAMES[providerCode] ? BANK__NAMES[providerCode] : providerName;
};

const getProviderIcon = (providerCode: string) => {
  return BANK__ICONS[providerCode]
    ? BANK__ICONS[providerCode]
    : BANK__ICONS["other"];
};

const MAX_CARD_NUM_LENGTH = 16;

export const FirstStep = ({
  offer,
  callBack,
  defaultIcon,
  bankName,
}: {
  offer: IOffer;
  callBack?: () => void;
  defaultIcon: boolean;
  bankName: boolean;
}) => {
  const [card, setCard] = useState("");
  const changeCard = (val: string) => {
    setCard(val);
  };
  const [isReqSending, setReqStatus] = useState(false);
  const [response, setResponse] = useState({
    success: true,
    mesg: "",
  });

  const updateCardReq = async () => {
    if (offer) {
      setReqStatus(true);
      const resp = await updateOfferVisitorCardNum(offer.id, card);
      setResponse({
        success: resp.success,
        mesg: resp.message,
      });
      resp.success && callBack && callBack();
      setReqStatus(false);
    }
  };

  const isCardNumValid = card.length === MAX_CARD_NUM_LENGTH;

  return (
    <FormContainer>
      {" "}
      <Form>
        <h2 className={styles.form_title}>Проверка карты отправителя</h2>
        <p className={styles.form_descr}>
          Для безопасности платежа подтвердите карту
        </p>
        <div className={styles.bank_details_container}>
          {isCardNumValid && (
            <div className={styles.provider_container}>
              <div className={styles.provider_bank}>
                <div className={styles.provider_bank_icon_container}>
                  <img
                    className={styles.provider_bank_icon}
                    src={getProviderIcon(defaultIcon ? "" : offer.providerCode)}
                    alt="icon"
                  />
                </div>
                {bankName && (
                  <div className={styles.provider_bank_title}>
                    {getBankName(offer.providerCode, offer.providerName)}
                  </div>
                )}
              </div>
              <img src={getPaymentType(card)} alt="icon" />
            </div>
          )}
          <div className={styles.input_wrapper}>
            <Input
              value={card}
              onChange={changeCard}
              mask="0000 0000 0000 0000"
              placeholder="_ _ _ _  _ _ _ _  _ _ _ _  _ _ _ _"
              resetValue={() => {
                setCard("");
              }}
            />
            {!response.success && (
              <div className={styles.input_wrapper_alert}>
                <img src={alertIcon} alt="icon" />
                <div>{response.mesg}</div>
              </div>
            )}
          </div>
        </div>
        <Button
          content="Далее"
          disabled={!isCardNumValid || isReqSending}
          onClick={updateCardReq}
          variant="primary"
        />
      </Form>
      {offer.goodLink && (
        <Link
          variant="hollow"
          content="Вернуться на сайт"
          className={styles.btn}
          href={offer.goodLink}
          target="_blank"
        />
      )}
    </FormContainer>
  );
};
